import React, { useContext } from 'react';
import { connect, useDispatch } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Button, Grid } from 'semantic-ui-react';

// Global Services
import { AppState } from 'services/types';
import { VirtualizedTableItem } from 'services/virtualizedTable/types';
// @ts-ignore
import { selectVirtualizedTableSelectedItemsArray } from 'services/virtualizedTable/selectors';
import { updateQueryString } from 'services/router/actions';
import { deleteItems } from 'services/virtualizedTable/actions';
// @ts-ignore
import { resetSelectedTableCells } from 'services/selectedTableCells/actions';

import QueryStringButton from 'components/QueryStringButton';

import { VirtualizedTableContextProviderValue } from '../../types';
import VirtualizedTableContext from '../VirtualizedTableContext';
import { DELETE_MODAL_QUERY_STRING_PARAM } from '../../constants';

interface ConnectedProps {
    selectedItems: VirtualizedTableItem[];
}

type Props = ConnectedProps;

export const VirtualizedTableDeleteFormWrapperComponent = (
    props: Props
): React.ReactElement => {
    const { selectedItems } = props;
    const dispatch = useDispatch();
    const { label, labelPlural, onDelete } = useContext<
        VirtualizedTableContextProviderValue
    >(VirtualizedTableContext);

    const onClick = (): void => {
        dispatch(deleteItems(selectedItems.map((item) => item.key)));
        dispatch(
            updateQueryString({
                [DELETE_MODAL_QUERY_STRING_PARAM]: undefined
            })
        );
        dispatch(resetSelectedTableCells());
        if (onDelete) onDelete(selectedItems);
    };

    const itemLabel =
        selectedItems.length === 1 ? label || 'item' : labelPlural || 'items';

    return (
        <React.Fragment>
            <p>Are you sure you want to delete the selected {itemLabel}?</p>
            <Grid>
                <Grid.Column mobile={16} tablet={8} computer={8}>
                    <QueryStringButton
                        params={{
                            [DELETE_MODAL_QUERY_STRING_PARAM]: undefined
                        }}
                        buttonProps={{
                            type: 'button',
                            fluid: true,
                            basic: true,
                            primary: true
                        }}
                        ignoreActive
                    >
                        Cancel
                    </QueryStringButton>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={8} computer={8}>
                    <Button
                        type="button"
                        negative
                        primary
                        fluid
                        onClick={onClick}
                    >
                        Delete
                    </Button>
                </Grid.Column>
            </Grid>
        </React.Fragment>
    );
};

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    selectedItems: selectVirtualizedTableSelectedItemsArray
});

export default connect(mapStateToProps)(
    VirtualizedTableDeleteFormWrapperComponent
);
